import { render, staticRenderFns } from "./section-4.vue?vue&type=template&id=72301733&"
import script from "./section-4.vue?vue&type=script&lang=js&"
export * from "./section-4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports